import React from 'react';

const S = ({
    w = 'w-full',
    h = 'h-4',
    r = 'rounded-lg',
    cls = '',
}: {
    w?: string;
    h?: string;
    r?: string;
    cls?: string;
}) => (
    <div
        className={`${w} ${h} ${r} ${cls} flex-shrink-0`}
        style={{
            background: 'linear-gradient(90deg,var(--v2-border-subtle) 25%,var(--v2-border-card) 50%,var(--v2-border-subtle) 75%)',
            backgroundSize: '200% 100%',
            animation: 'skeletonShimmer 1.6s ease-in-out infinite',
        }}
    />
);

const ProcessingSkeleton: React.FC = () => (
    <div className="flex gap-3 v2-animate-fade-in" style={{ minHeight: 400 }}>
        <div className="w-52 flex-shrink-0 rounded-2xl border border-[var(--v2-border-card)] bg-[var(--v2-bg-card)] overflow-hidden flex flex-col" style={{ boxShadow: 'var(--v2-shadow-card)' }}>
            <div className="px-3 py-2.5 border-b border-[var(--v2-border-subtle)]">
                <S w="w-20" h="h-2.5" r="rounded-md" />
            </div>
            {Array.from({ length: 5 }).map((_, i) => (
                <div key={i} className="px-3 py-3 border-b border-[var(--v2-border-divider)] last:border-0 flex items-center justify-between gap-2">
                    <div className="flex flex-col gap-1.5 flex-1 min-w-0">
                        <S w="w-28" h="h-2.5" r="rounded-md" />
                        <S w="w-16" h="h-2" r="rounded-md" />
                    </div>
                    <S w="w-14" h="h-5" r="rounded-full" />
                </div>
            ))}
        </div>

        <div className="flex-1 rounded-2xl border border-[var(--v2-border-card)] bg-[var(--v2-bg-card)] p-4 flex flex-col gap-4" style={{ boxShadow: 'var(--v2-shadow-card)' }}>
            <div className="flex items-center justify-between">
                <div className="flex flex-col gap-1.5">
                    <S w="w-40" h="h-4" r="rounded-lg" />
                    <S w="w-24" h="h-2.5" r="rounded-md" />
                </div>
                <S w="w-20" h="h-6" r="rounded-full" />
            </div>

            <div className="rounded-xl border border-[var(--v2-border-card)] overflow-hidden">
                <div className="flex gap-4 px-4 py-2 border-b border-[var(--v2-border-subtle)]">
                    {[140, 90, 120, 80].map((w, i) => (
                        <S key={i} w={`w-[${w}px]`} h="h-2.5" r="rounded-md" />
                    ))}
                </div>
                {Array.from({ length: 5 }).map((_, i) => (
                    <div key={i} className="flex gap-4 px-4 py-3 border-b border-[var(--v2-border-divider)] last:border-0 items-center">
                        <S w="w-[140px]" h="h-2.5" r="rounded-md" />
                        <S w="w-[90px]" h="h-8" r="rounded-lg" />
                        <S w="w-[120px]" h="h-2.5" r="rounded-md" />
                        <S w="w-[80px]" h="h-2.5" r="rounded-md" />
                    </div>
                ))}
            </div>

            <div className="flex flex-col gap-2">
                <S w="w-20" h="h-2.5" r="rounded-md" />
                <S w="w-full" h="h-20" r="rounded-xl" />
            </div>
            <div className="flex flex-col gap-2">
                <S w="w-24" h="h-2.5" r="rounded-md" />
                <S w="w-full" h="h-16" r="rounded-xl" />
            </div>

            <div className="flex gap-2 mt-auto">
                <S w="w-28" h="h-9" r="rounded-xl" />
                <S w="w-24" h="h-9" r="rounded-xl" />
                <S w="w-36" h="h-9" r="rounded-xl" />
            </div>
        </div>
    </div>
);

export default ProcessingSkeleton;
